import { render, staticRenderFns } from "./DriverAddMobile.vue?vue&type=template&id=0872d3b0&"
import script from "./DriverAddMobile.vue?vue&type=script&lang=js&"
export * from "./DriverAddMobile.vue?vue&type=script&lang=js&"
import style0 from "./DriverAddMobile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports